import { render, staticRenderFns } from "./Ebanking.vue?vue&type=template&id=2c915beb&scoped=true&"
import script from "./Ebanking.vue?vue&type=script&lang=js&"
export * from "./Ebanking.vue?vue&type=script&lang=js&"
import style0 from "./Ebanking.vue?vue&type=style&index=0&id=2c915beb&lang=scss&scoped=true&"
import style1 from "./Ebanking.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c915beb",
  null
  
)

export default component.exports